module.exports = __webpack_public_path__ + "img/MR.aa72dd9d.svg";